import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import ButtonDropdown from 'components/ButtonDropdown';

import {
  fetchRevenueSummary,
  selectRevenueSummary,
  selectRevenueSummaryIsLoading,
  SUMMARY_RESOLUTION_OPTIONS
} from 'ducks/reporting';

import {getCurrentYearAndMonth} from 'utils/datetime';

import {formatMoney} from 'utils/money';
import Loader from 'components/Loader';

import './styles.css';

const Section = ({isLoading, heading, data, color = 'blue'}) => (
  <div className="Section colab-small-border-radius">
    <div className="Section__colorMarker" style={{backgroundColor: color}} />
    <div className="colab-heading">{heading}</div>
    {isLoading && (
      <div className="Section__loader colab-centered">
        <Loader />
      </div>
    )}
    {!isLoading && (
      <React.Fragment>
        <div className="Section__row colab-row-space-between">
          <div className="Section__subheading">{data.revenue.label}</div>
          <div className="colab-bold">
            £{formatMoney(Number(data.revenue.value))}
          </div>
        </div>
        <div className="Section__row colab-row-space-between">
          <div className="Section__subheading">{data.occupancy.label}</div>
          <div className="colab-bold">{data.occupancy.value}%</div>
        </div>
        <div className="Section__row colab-row-space-between">
          <div className="Section__subheading">{data.weeklyRate.label}</div>
          <div className="colab-bold">
            £{formatMoney(Number(data.weeklyRate.value))}
          </div>
        </div>
      </React.Fragment>
    )}
  </div>
);

class SummarySection extends React.Component<any> {
  componentDidMount() {
    const {locationRef, summaryResolution} = this.props;

    this.props.fetchRevenueSummary({
      locationRef,
      resolution: summaryResolution.value
    });
  }

  onResolutionChange = resolution => {
    const {locationRef} = this.props;

    this.props.onSummaryResolutionChange(resolution, () =>
      this.props.fetchRevenueSummary({
        locationRef,
        resolution: resolution.value
      })
    );
  };

  render() {
    const {summary, isLoading, summaryResolution} = this.props;

    return (
      <div className="SummarySection colab-medium-border-radius">
        <div className="SummarySection__header colab-row-space-between">
          <div>
            <div className="colab-heading">Summary</div>
            <div className="SummarySection__subheading">
              {getCurrentYearAndMonth()}
            </div>
          </div>
          <ButtonDropdown title={summaryResolution.label}>
            {_.keys(SUMMARY_RESOLUTION_OPTIONS).map(key => (
              <ButtonDropdown.Option
                key={SUMMARY_RESOLUTION_OPTIONS[key].value}
                onClick={() =>
                  this.onResolutionChange(SUMMARY_RESOLUTION_OPTIONS[key])
                }>
                {SUMMARY_RESOLUTION_OPTIONS[key].label}
              </ButtonDropdown.Option>
            ))}
          </ButtonDropdown>
        </div>
        {!_.isEmpty(summary) && (
          <div className="SummarySection__content">
            <Section
              heading="Confirmed"
              data={summary.confirmed}
              color="#5fba3f"
              isLoading={isLoading}
            />
            <Section
              heading="Forecast"
              data={summary.forecast}
              color="#a17fd8"
              isLoading={isLoading}
            />
            <Section
              heading="Projected"
              data={summary.projected}
              color="#2bc2bf"
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    summary: selectRevenueSummary(state),
    isLoading: selectRevenueSummaryIsLoading(state)
  };
};

const mapDispatchToProps = {
  fetchRevenueSummary
};

export default connect(mapStateToProps, mapDispatchToProps)(SummarySection);
